module.exports = __webpack_public_path__ + "static/media/geths-mantegna.daadbc63.jpg";